<div #el [hidden]="!visible" class="app-popover" role="dialog" aria-modal="false">
  <ng-content></ng-content>
</div>
